import api from 'utils/api';

const SET_VIEWPORT = 'map/SET_VIEWPORT';
const SET_USER_LOCATION = 'map/SET_USER_LOCATION';

export const setViewport = viewport => ({type: SET_VIEWPORT, viewport});
export const setUserLocation = userLocation => ({type: SET_USER_LOCATION, userLocation});

const initialState = {
    userLocation: null,
    viewport: {
        center: [59.43722, 24.74528],
        zoom: 13,
    },
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case SET_VIEWPORT:
            return {
                ...state,
                viewport: {
                    ...state.viewport,
                    ...action.viewport,
                },
            };

        case SET_USER_LOCATION:
            return {
                ...state,
                userLocation: action.userLocation,
            };

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/ducks/map.js